import React from 'react';

const DoctorPrivate = () => {
    return (
        <div className="text-center text-success">
            <h1>Private Doctor Information here</h1>
            <p> please Login First </p>

        </div>
    );
};

export default DoctorPrivate;